var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23 16.0313V18.6667M23 18.6667C23 19.6796 22.1796 20.5 21.1667 20.5H2.83333C1.82042 20.5 1 19.6796 1 18.6667M23 18.6667V5.83334C23 4.82042 22.1796 4 21.1667 4H15.6667M1 18.6667V5.83333C1 4.82042 1.82042 4 2.83333 4H16.3333M1 18.6667V16.0313M1 9.5H16.3333M23 9.5H15.6667",
    stroke: "#57486D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardOrder);
export default __webpack_public_path__ + "static/media/card-order.f57540cacbaf76f7dc22c40f696982e7.svg";
export { ForwardRef as ReactComponent };